import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import SaveIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
// styles
import styles from './styles';



class FormInstitution extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    institution: PropTypes.object,

    createInstitution: PropTypes.func,
    updateInstitution: PropTypes.func,
    deleteInstitution: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.institution);
    }
  }

  init(institution) {
    this.setState({
      loading: false,
      name: institution ? institution.name : '',
    });
  }

  handleChange = name => event => {
    const value = event.target.value;

    this.setState({
      [name]: value,
    });
  };

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: `Are you sure ?`,
        subtitle: 'If you delete this institution, you won\'t be able to recover it.',
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: 'Cancel',
          level: 'default',
          callback: () => console.log('Callback'),
        },
        confirm: {
          label: 'I am sure',
          level: 'error',
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const {
      deleteInstitution,
      close,
      refresh,
      institution,
    } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteInstitution(institution.id);
    if (resp.success) {
      NotificationCenter.sweetAlert(
        {
          title: 'Institution has been deleted.',
          success: true,
          timestamp: new Date().getTime(),
        },
      );
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateInstitution,
      createInstitution,
      institution,
      refresh,
      close,
    } = this.props;

    const {
      name,
    } = this.state;

    const {
      NotificationCenter,
    } = this.context;

    let resp = undefined;
    this.setState({ loading: true });
    if (institution) {
      resp = await updateInstitution(
        institution.id,
        {
          name,
        }
      );
    } else {
      resp = await createInstitution({
        name,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert(
        {
          title: institution ? 'Institution has been updated.' : 'Institution has been created.',
          success: true,
          timestamp: new Date().getTime(),
        },
      );

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const {
      classes,
      fullScreen,
      open,
      institution,
      close,
    } = this.props;

    const {
      name,
      loading,
    } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {
          loading ?
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">
              Loading
            </DialogTitle>
            <CircularProgress />
          </div>
          :
          <div>
            <DialogTitle id="responsive-dialog-title">
              {
                institution ?
                `${institution.name}`
                :
                'Let\'s Create a New Institution'
              }
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {
                  institution ?
                  'To update the institution, fill the form below :'
                  :
                  'To create a new institution, fill the form below :'
                }
              </DialogContentText>
              <Grid container spacing={24}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name *"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange('name')}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions
              className={classes.dialogActions}
            >
              {
                institution ?
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} /> Delete
                </Button>
                :
                []
              }
              <Button
                onClick={close}
              >
                <CloseIcon className={classes.leftIcon} /> Close
              </Button>
              <Button
                color="primary"
                autoFocus
                onClick={this.save.bind(this)}
              >
                <SaveIcon className={classes.leftIcon} /> {
                  institution ?
                  'Save'
                  :
                  'Create'
                }
              </Button>
            </DialogActions>
          </div>
        }
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormInstitution));
